import { environmentConfig } from "../environment";

export const HELP_CENTER_PATH = "help-center";
export const HELP_CENTER_FULL_PATH = `/v2/home/${HELP_CENTER_PATH}`;

/** Zendesk Help Center home; SSO `return_to` lands the user here. */
export const ZENDESK_HELP_CENTER_HOME_PATH = "/hc/en-us";

export const FACILITY_HELP_SUPPORT_LINK =
  environmentConfig.REACT_APP_FACILITY_SUPPORT_ARTICLES_LINK ||
  "https://support.clipboardhealth.com/hc/en-us/categories/4943215926167-Facilities";
